import axios from 'axios'
import services from '@/config/services'
import authHeader from '../auth/auth-header';
import Cookies from 'js-cookie';
import FileManager from '@/services/ask-file-manager/index.js'

export default class UtilityService {
    constructor(eventBus){
        this.eventBus = eventBus
        this.baseUrl = `${services.ask_api.url}/management`;
        this.baseUrlToken = `${services.ask_pratiche_token.url}`
        this.baseUrlApi = `${services.ask_pratiche_api.url}`
        this.baseUrlFlussi = `${services.ask_flussi_api.url}`
        this.baseUrlScraper = `${services.ask_pratiche_scraper.url}`
        this.baseAdminUrl = `${services.admin.url}`
        this.filemanager = new FileManager()
        axios.interceptors.request.use(
            (req) => {
                req.headers["Authorization"] = authHeader()
                req.headers["Params"] = Cookies.get('google_access_token') || Cookies.get('ask_access_token')
                // this.eventBus.emit('data-loading');
                return req
            }
        )
    }

  async getAgenti(direct = 0) {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/agenti/${direct}`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getAgentiPerGettoni(direct = 0) {
    let items = [];

    const url = `${this.baseUrl}/utility/agenti-per-gettoni/${direct}`;

    try {
      let res = await axios.get(url);
      
      if (res.data.meta && res.data.meta.success === false) {
        throw new Error(res.data.meta.status.message);
      }
      
      items = res.data.data || [];
      
    } catch (err) {
      console.error('Errore completo:', err);
      this.eventBus.emit("data-load-error", {
        message: err.message || 'Errore nel recupero degli agenti',
        url
      });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: items.length,
        success: items.length > 0
      };
    }
  }


  async getAgenzie() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/agenzie`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getSubAgenti(idAgente) {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/subagenti/${idAgente}`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getComuni() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/comuni`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getDistributoriEnergia() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/distributori-energia`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getGiorniScadenza() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/giorni-scadenza`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getCodiciIva() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/codici-iva`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getListaRappresentanti() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-rappresentanti`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getListaClienti() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-clienti`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getListaOfferte() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-offerte`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }
  async getOfferteAgent(id){
    let items = []
    const url = `${this.basePraticheUrl}/get-offerte-for-agent-${id}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getListaOfferteAttive() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-offerte-attive`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiAllegato() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-allegato`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTypeAccisa() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-accisa`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async downloadScansioni(item) {
    const url = `${this.baseUrl}/utility/scansioni/download/pdf`;
    try {
      let res = await axios({
        url,
        method: "POST",
        data: { data: item },
        responseType: "blob",
      });

      this.filemanager.download(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async openScansioni(item) {
    const url = `${this.baseUrl}/utility/scansioni/download/pdf`;
    try {
      let res = await axios({
        url,
        method: "POST",
        data: { data: item },
        responseType: "blob",
      });

      this.filemanager.open(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async downloadDocumenti(item) {
    const url = `${this.baseUrl}/utility/documenti/download`;
    try {
      let res = await axios({
        url,
        method: "POST",
        data: { data: item },
        responseType: "blob",
      });

      this.filemanager.download(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async openDocumenti(item) {
    const url = `${this.baseUrl}/utility/documenti/download`;
    try {
      let res = await axios({
        url,
        method: "POST",
        data: { data: item },
        responseType: "blob",
      });

      this.filemanager.open(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async uploadDocumenti(fd) {
    const url = `${this.baseUrl}/utility/documenti/upload`;
    const settings = { headers: { "content-type": "multipart/form-data" } };

    try {
      const res = await axios.post(url, fd, settings);
      if (res.data.success) {
        this.eventBus.emit("data-load-success", { message: res.data.msg });
      } else {
        this.eventBus.emit("data-load-error", { message: res.data.msg });
      }
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async sendPushNotice(fd) {
    const url = `${this.baseUrl}/push-notification`;
    let item;
    try {
      await axios.post(url, fd).then((res) => {
        item = res.data;
      });
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
    return { item };
  }

  async getTipiCliente() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-cliente`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiCategoriaCliente() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-categoria-cliente`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiAliquotaIva() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-aliquota-iva`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiMetodoPagamento() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-metodo-pagamento`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiMetodoPagamentoCliente() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-metodo-pagamento-cliente`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiMisuratore() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-misuratore`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiContrattoVendita() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-contratto-vendita`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiFatturazione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-fatturazione`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiTariffazione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-tariffazione`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiTensione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-tensione`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiOfferta() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-offerta`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiPeriodoFatturazione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-periodo-fatturazione`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiAcquisizione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-acquisizione`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiResidente() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-residente`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiRid() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-rid`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiSpedizione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-spedizione`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async geTipiStatoContratto() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-stato-contratto`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }
  async geTipiStatoFornitura() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-stato-fornitura`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async geTipiStatoFornituraSospensioniRiattivazioni() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-stato-fornitura-sosp-riat`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async geMotivazioniStatoContrattoKo() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/motivazioni-stato-contratto-ko`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiStima() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-stima`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiUso() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-uso`;

    try {
      let res = await axios.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getFatturaVoci() {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura-voci`;

    try {
      let res = await axios.get(url);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async downloadTemplateFatturaVociMassivo() {
    const url = `${this.baseUrl}/utility/fattura-voci/template/massivo/download`;
    try {
      let res = await axios({
        url,
        method: "GET",
        // data: {data:item},
        responseType: "blob",
      });

      this.filemanager.download(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async getFatturaSezioni() {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura-sezioni`;

    try {
      let res = await axios.get(url);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async getFatturaTypePrezzo() {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura-type-prezzo`;

    try {
      let res = await axios.get(url);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async addVoceInFattura(item, type) {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura/voce/create`;

    try {
      let res = await axios.post(url, {
        data: item,
        type: type,
      });

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async addConsumo(newConsumo, podCode) {
    const url = `${this.baseUrl}/utility/fattura/voce/createConsumoDistributore`;

    try {
      let res = await axios.post(url, { ...newConsumo, podCode });

      if (res.status === 200) {
        return {
          success: true,
          message: "Consumo aggiunto con successo",
        };
      } else {
        throw new Error("Errore durante l'aggiunta del consumo");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      return {
        success: false,
        message: `Errore durante l'aggiunta del consumo: ${error.message}`,
      };
    }
  }

  async addConsumoGas(newConsumo, pdrCode) {
    const url = `${this.baseUrl}/utility/fattura/voce/createConsumoDistributoreGas`;
  
    try {
      let res = await axios.post(url, { ...newConsumo, pdrCode, saveconsumo: true });
      console.log("Response:", res);
  
      if (res.status === 200 && res.data.success) {
        return {
          success: true,
          message: "Consumo aggiunto con successo",
          data: res.data.data
        };
      } else {
        throw new Error(res.data.message || "Errore durante l'aggiunta del consumo");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      return {
        success: false,
        message: `Errore durante l'aggiunta del consumo: ${error.message}`,
      };
    }
  }
  
  async getConsumoGas(code) {
    const url = `${this.baseUrl}/utility/fattura/voce/getConsumoDistributoreGas`;
  
    try {
      let res = await axios.post(url, { code });
      console.log("Response:", res);
  
      if (res.status === 200) {
        return {
          success: true,
          items: res.data.items,
          message: "Dati del consumo recuperati con successo",
        };
      } else {
        throw new Error("Errore durante il recupero dei dati del consumo");
      }
    } catch (error) {
      console.error("Errore occorso:", error);
      return {
        success: false,
        message: `Errore durante il recupero dei dati del consumo: ${error.message}`,
      };
    }
  }
  
  
  

  async getConsumo(podId) {
    const url = `${this.baseUrl}/utility/fattura/voce/getConsumoDistributore`;
  
    try {
      let res = await axios.post(url, { podId: podId },);
      
  
      if (res.status === 200 && res.data.success) {
        return {
          success: true,
          items: res.data.items || [],
          message: "Dati del consumo recuperati con successo",
        };
      } else {
        return {
          success: false,
          message: res.data.message || "Errore durante il recupero dei dati del consumo",
        };
      }
    } catch (error) {
      console.error("Errore occorso:", error);
      return {
        success: false,
        message: `Errore durante il recupero dei dati del consumo: ${error.message}`,
      };
    }
  }

  async addVoceInFatturaFromFile(file, type) {
    let items = [];
    const settings = { headers: { "content-type": "multipart/form-data" } };
    const url = `${this.baseUrl}/utility/fattura/voce/massivo/create`;
    let fd = new FormData();
    fd.append("type", type);
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }

    try {
      let res = await axios.post(url, fd, settings);
      items = res.data;
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async onDeleteFatturaVoce(id, type) {
    const url = `${this.baseUrl}/utility/fattura/voce/${type}/${id}/delete`;

    try {
      await axios.get(url);

      return true;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
      return false;
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async caricamentoConsumiFile(file, type) {
    let items = [];
    const settings = { headers: { "content-type": "multipart/form-data" } };
    const url = `${this.baseUrl}/utility/caricamento/consumi/file`;
    let fd = new FormData();
    fd.append("type", type);
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }

    try {
      let res = await axios.post(url, fd, settings);
      items = res.data;
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async caricamentoLettureFile(file, type) {
    let items = [];
    const settings = { headers: { "content-type": "multipart/form-data" } };
    const url = `${this.baseUrl}/utility/caricamento/letture/file`;
    let fd = new FormData();
    fd.append("type", type);
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }

    try {
      let res = await axios.post(url, fd, settings);
      items = res.data;
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async showPdfOfferta(id, id_agente) {
    const url = `${this.baseUrlFlussi}/proposta/scarica-pdf-offerta-${id}-${id_agente}`;
    try {
      let res = await axios({
        url,
        method: "GET",
        responseType: "blob",
      });
      this.filemanager.download(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async updateDateRcu(obj, type) {
    let item = {};

    const url = `${this.baseUrl}/utility/${type}/rcu/date/update`;

    try {
      let res = await axios.post(url, { obj });

      item = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
      };
    }
  }

  async viewAllLetture(code, type) {
    let items = [];
    const url = `${this.baseUrl}/utility/${type}/all/letture`;

    try {
      let res = await axios.post(url, { code });

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }
  async setAllVoceFattura(fd, method) {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura/voce/create-all-${method}`;

    try {
      let res = await axios.post(url, fd);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }
  async getFattureVoce(fd, method) {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura/voce/get-fatture-${method}`;

    try {
      let res = await axios.post(url, fd);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }
  async getScalaAgenti(id){
    let item = {}

    const url = `${this.baseUrl}/agenti/scala-agenti/${id}`
    try {
      let res = await axios.get(url)
      
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async viewDocumento_wizard(id, name){
    let item = [];
    const url = `${this.basePraticheUrl}/view-document`
    try {
      const res = await axios.post(
        url, 
        {
            'matrice_id':id,
            'file':name
        }
      )
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded') 
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }     
    }
  }

  async downloadDocumento_wizard(id, filename){
    const url = `${this.basePraticheUrl}/multisito/download-file-caricamento`
    try {
      let res = await axios({url,
          method: 'POST',
          data: {
            matrice_id: id,
            file: filename,
            // dir: directory
          },
          responseType: 'blob',
        })
      //this.eventBus.emit('data-load-success', {message: res.data})

      this.filemanager.download(res)

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')   
    }
  }

}
